import styles from './ArtistBanner.module.scss';
import React from 'react';
import { MEDIA_BREAKPOINTS } from '../../../../constants/MEDIA_BREAKPOINTS';
import { clsx } from '../../../../utils/clsx';
export const ArtistBannerSkeleton = () => (React.createElement("div", { className: clsx('skeleton bdrs:2 w:100vw h:auto', styles.container), style: {
        aspectRatio: MEDIA_BREAKPOINTS.XL_UP.matches ? '4741 / 1521' : '2801 / 1169'
    } }));
